// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bg-logo-common.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/bg-logo-common-sm.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription_subscription__Bl4Pe {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 80px 17% 100px;
  overflow-x: hidden;
  background-color: #f5f5ff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.Subscription_subscription__Bl4Pe.Subscription_justify-center__pJKyZ {
  justify-content: center;
}

.Subscription_header__FxjOw {
  position: fixed;
  top: 0;
  left: 0;
}

.Subscription_back__m\\+HCU {
  position: initial;
  align-self: flex-start;
  margin-bottom: 24px;
}

.Subscription_notices__D82k7 {
  position: fixed;
  z-index: 1;
  bottom: 0;
  width: 100vw;
  border-top: 1px solid #d8d8ff;
  background: #fff;
  font-size: 14px;
  font-weight: 300;
  line-height: 24px;
}
.Subscription_notices__D82k7 .Subscription_collapsible__rjqIY {
  padding: 12px 30px;
  background: #fff;
}
.Subscription_notices-title__qarxn {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #00007a;
}

@media screen and (max-width: 900px) {
  .Subscription_notices-opened__dVkQE {
    position: absolute;
    height: 80vh;
  }
}
@media screen and (max-width: 600px) {
  .Subscription_subscription__Bl4Pe {
    padding: 77px 20px 150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: bottom;
    background-size: 100%;
  }
  .Subscription_header__FxjOw {
    position: absolute;
    padding: 12px 20px 18px;
  }
  .Subscription_back__m\\+HCU {
    margin-bottom: 16px;
    padding: 0;
  }
  .Subscription_progress__eKp0V {
    margin-bottom: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/Subscription.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBCXS;EDYT,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAIF;AAFE;EACE,uBAAA;AAIJ;;AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;AAGF;;AAAA;EACE,iBAAA;EACA,sBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGF;AADE;EACE,kBAAA;EACA,gBAAA;AAGJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC/CO;ADiDX;;AAEA;EACE;IACE,kBAAA;IACA,YAAA;EACF;AACF;AAEA;EACE;IACE,wBAAA;IACA,yDAAA;IACA,2BAAA;IACA,qBAAA;EAAF;EAGA;IACE,kBAAA;IACA,uBAAA;EADF;EAIA;IACE,mBAAA;IACA,UAAA;EAFF;EAKA;IACE,mBAAA;EAHF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.subscription {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  padding: 80px 17% 100px;\n  overflow-x: hidden;\n  background-color: colors.$primary1;\n  background-image: url(../../assets/bg-logo-common.svg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  &.justify-center {\n    justify-content: center;\n  }\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.back {\n  position: initial;\n  align-self: flex-start;\n  margin-bottom: 24px;\n}\n\n.notices {\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  width: 100vw;\n  border-top: 1px solid colors.$primary2;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 24px;\n\n  .collapsible {\n    padding: 12px 30px;\n    background: #fff;\n  }\n\n  &-title {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .notices-opened {\n    position: absolute;\n    height: 80vh;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .subscription {\n    padding: sizes.$nav-menu-mobile-height 20px 150px;\n    background-image: url(../../assets/bg-logo-common-sm.svg);\n    background-position: bottom;\n    background-size: 100%;\n  }\n\n  .header {\n    position: absolute;\n    padding: 12px 20px 18px;\n  }\n\n  .back {\n    margin-bottom: 16px;\n    padding: 0;\n  }\n\n  .progress {\n    margin-bottom: 28px;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"subscription": `Subscription_subscription__Bl4Pe`,
	"justify-center": `Subscription_justify-center__pJKyZ`,
	"header": `Subscription_header__FxjOw`,
	"back": `Subscription_back__m+HCU`,
	"notices": `Subscription_notices__D82k7`,
	"collapsible": `Subscription_collapsible__rjqIY`,
	"notices-title": `Subscription_notices-title__qarxn`,
	"notices-opened": `Subscription_notices-opened__dVkQE`,
	"progress": `Subscription_progress__eKp0V`
};
export default ___CSS_LOADER_EXPORT___;
